import { getLocale } from "../runtime";

const sv_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ogiltig rabattkod. Försök igen.`
};

const invalidpromocode = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_invalidpromocode(inputs)
	return "invalidPromoCode";
};

export { invalidpromocode as "invalidPromoCode" };